// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';
import {IndividualNameLogs} from './individual-name-logs';
import {EntityLogs} from './entity-logs';
import {PhoneFaxLogs} from './phone-fax-logs';
import {EmailLogs} from './email-logs';

export const BusinessContactLogs = t.struct({
    contactId: t.Number,
    indivNameLogs: t.list(IndividualNameLogs),
    entityLogs: t.list(EntityLogs),
    phoneFaxLogs: t.list(PhoneFaxLogs),
    emailLogs: t.list(EmailLogs)
}, {
    defaultProps: {
        contactId: 0,
        indivNameLogs: [],
        entityLogs: [],
        phoneFaxLogs: [],
        emailLogs: []
    },
    name: 'BusinessContactLogs',
    strict: true
});
